import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/CertificateOfOrigin/components/SectionPurpose/SectionPurpose.module.scss';

const cn = classNames.bind(styles);

const SectionPurpose = (): ReactElement => {
  return (
    <section className={cn('purpose')}>
      <div className={cn('container')}>

        <div className={cn('purpose__section')}>

          <div className={cn('purpose__image-box')}>
            <picture>
              <source
                srcSet="
                /images/pages/Resources/FreightTemplates/sign-in.webp 1x,
                /images/pages/Resources/FreightTemplates/sign-in@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('purpose__image')}
                src="/images/pages/Resources/FreightTemplates/sign-in.webp"
                alt="bill of lading"
              />
            </picture>
          </div>

          <div className={cn('purpose__content')}>
            <h2 className={cn('purpose__heading')}>
              <span>Why bother with </span>{' '}
              <span>a Certificate of Origin?</span>
            </h2>
            <p className={cn('purpose__paragraph')}>
              Money. That’s the short answer.
            </p>
            <ul className={cn('purpose__list')}>
              <li className={cn('purpose__list-item')}>
                <span>Preferential CO:</span>{' '}
                This is used when there is a trade agreement (like the CEPA between
                India and UAE). It can drop
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Non-Preferential CO:</span>{' '}
                Sometimes, you just need to prove origin for political reasons or
                to comply with quotas, even if there is no tax break. For a forwarder, ensuring the CO is
                in the packet means your client pays less tax and clears customs faster.
              </li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SectionPurpose;